import FieldSet from '../../FieldSet';

import { Score } from './Score';

export class ScoreFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [Score];
  }

  get title() {
    return 'Product value score';
  }
}
